"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERROR_MESSAGES = exports.DEFAULT_INTENT = exports.INTENTS = exports.DEFAULT_EVENTS = exports.noOp = exports.WEBSOCKET_COMMAND_FAILED_EVENT_NAME = exports.WEBSOCKET_FILE_UPLOAD_SUCCESS_EVENT_NAME = exports.WEBSOCKET_TOPIC_NAME = exports.WRITE_REST_UPLOAD_PUBLIC_ENDPOINT = exports.WRITE_REST_UPLOAD_ENDPOINT = exports.WRITE_REST_UPLOAD_PUBLIC_PREPARE_URI = exports.WRITE_REST_UPLOAD_PREPARE_URI = exports.WEBSOCKET_SUBSCRIPTION_TIMEOUT_MS = exports.WEBSOCKET_INIT_TIMEOUT_MS = exports.FIRST_DELAY_MS = exports.BACKOFF_RATE_SERVER_ERROR = exports.BACKOFF_RATE_CLIENT_ERROR = exports.MAX_RETRIES_SERVER_ERROR = exports.MAX_RETRIES_CLIENT_ERROR = exports.MAX_JOBS = exports.DEFAULT_CHUNK_SIZE = void 0;
exports.DEFAULT_CHUNK_SIZE = 5120 * 1024; // 5MB
exports.MAX_JOBS = 4;
// TODO: Remove the following 5 lines as they might not be used anymore
exports.MAX_RETRIES_CLIENT_ERROR = 72000; // TODO: Lower amount of retries for a client error
exports.MAX_RETRIES_SERVER_ERROR = 10;
exports.BACKOFF_RATE_CLIENT_ERROR = 1;
exports.BACKOFF_RATE_SERVER_ERROR = 1.5;
exports.FIRST_DELAY_MS = 500; // 0.5 sec.
exports.WEBSOCKET_INIT_TIMEOUT_MS = 500000; // 500 sec.
exports.WEBSOCKET_SUBSCRIPTION_TIMEOUT_MS = 1000 * 60 * 30; // 30 min.
exports.WRITE_REST_UPLOAD_PREPARE_URI = '/v7/file_cmds/upload/prepare';
exports.WRITE_REST_UPLOAD_PUBLIC_PREPARE_URI = '/v7/public_file_cmds/upload/prepare';
exports.WRITE_REST_UPLOAD_ENDPOINT = '/v7/file_cmds/upload';
exports.WRITE_REST_UPLOAD_PUBLIC_ENDPOINT = '/v7/public_file_cmds/upload';
exports.WEBSOCKET_TOPIC_NAME = 'files-messages';
exports.WEBSOCKET_FILE_UPLOAD_SUCCESS_EVENT_NAME = 'FileUploadedSuccess';
exports.WEBSOCKET_COMMAND_FAILED_EVENT_NAME = 'FailedEvent';
function noOp() {
    // empty function
}
exports.noOp = noOp;
exports.DEFAULT_EVENTS = {
    onRegistered: noOp,
    onCompleted: noOp,
    onConfirmed: noOp,
    onWarning: noOp,
    onError: noOp
};
exports.INTENTS = [
    'upload_account_login_logo',
    'upload_account_logo',
    'upload_asset_additional',
    'upload_asset_derivative',
    'upload_asset_version',
    'upload_background',
    'upload_custom_thumbnail',
    'upload_main_uploader_asset',
    'upload_metaproperty_option_image',
    'upload_news_image',
    'upload_profile_image',
    'upload_styleguide_chapter_image',
    'upload_styleguide_page_image',
    'upload_transfer_file',
    'upload_via_api',
    'upload_watermark',
    'upload_workflow_asset',
    'upload_workflow_job_attachment',
    'upload_workflow_preset_attachment',
    'upload_workflow_campaign_image',
    'upload_guidelines_asset',
    'upload_mass_uploader',
    'upload_account_favicon'
];
exports.DEFAULT_INTENT = 'upload_via_api';
exports.ERROR_MESSAGES = {
    USER_CANCELLED: 'Upload canceled by the user',
    NETWORK_ERROR: 'Network Error'
};
//# sourceMappingURL=index.js.map